import { type ImportSourceType } from '~/utils/ImportUtils';

export type ExcludedIntegrationType = 'slack' | ImportSourceType;

export type ExcludedIntegrationsFlagResult = {
  excludedIntegrations: ExcludedIntegrationType[];
  excludedImportSources: ImportSourceType[];
};

const VALID_INTEGRATIONS: readonly ExcludedIntegrationType[] = [
  // integrations
  'slack',
  // import/clip sources
  'dropbox',
  'googleDrive',
  'box',
  'brandfolder',
  'canto',
  'sharePoint',
  'frameio',
] as const;

const EMPTY_EXCLUDED_INTEGRATIONS_FLAG_RESULT: ExcludedIntegrationsFlagResult = {
  excludedIntegrations: [],
  excludedImportSources: [],
};

const isValidIntegration = (integration: string): integration is ExcludedIntegrationType => {
  return VALID_INTEGRATIONS.some((validIntegration) => validIntegration === integration);
};

const isImportSourceType = (integration: ExcludedIntegrationType): integration is ImportSourceType => {
  return integration !== 'slack';
};

export const parseExcludedIntegrationsFlag = (excludedIntegrationsFlag: unknown): ExcludedIntegrationsFlagResult => {
  if (!excludedIntegrationsFlag || !Array.isArray(excludedIntegrationsFlag) || excludedIntegrationsFlag.length === 0) {
    return EMPTY_EXCLUDED_INTEGRATIONS_FLAG_RESULT;
  }

  const list = excludedIntegrationsFlag.map((integration) => String(integration).trim()).filter(isValidIntegration);

  return {
    excludedIntegrations: list.filter((integration) => integration === 'slack'),
    excludedImportSources: list.filter(isImportSourceType),
  };
};
